import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Navbar from "../common/component/navbar.js";
import BottomBar from "../common/component/bottomBar.js";
import AnimatedText from "../common/component/HeadingAnimation.js"
import OurServices from "../common/component/ourServices.js";
import Searching from "../common/component/Search.js";
import { liveUrl, token } from "../common/component/url.js";
import ImageOne from "../../src/assets/img/image-not.jpg";
import Bed from "../../src/assets/img/bed.png";
import Bath from "../../src/assets/img/bath.png";
import Kitchen from "../../src/assets/img/kitchen.png";
import "../common/component/ModalPage.css";
import Cookies from "js-cookie";
import Report from "../common/component/Report.js";
import { FaBug, FaFlag } from "react-icons/fa";
import WhatsAppChat from "../common/component/WhatsAppChat.js";

Modal.setAppElement("#root");

export default function UserInformation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const propertyId = id?.split("-").pop();

  // State management
  const [propertyData, setPropertyData] = useState(null);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState("main");
  const [showAllAmenities, setShowAllAmenities] = useState(false);
  const [showAllDetails, setShowAllDetails] = useState(false);
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    phone: "",
    visitDate: null,
    visitTime: "",
  });
  const [errors, setErrors] = useState({
    firstname: "",
    phone: "",
    visitDate: "",
    visitTime: "",
  });
  const [userBookings, setUserBookings] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState({
    firstname: "",
    phone: "",
  });
  const [userInfoModal, setUserInfoModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showReport, setShowReport] = useState(false);
  const [scheduledDate, setScheduledDate] = useState(null);
  const [scheduledTime, setScheduledTime] = useState("");
  const [fieldTouched, setFieldTouched] = useState({
    firstname: false,
    phone: false,
  });
  const [validationErrors, setValidationErrors] = useState({
    firstname: "",
    phone: "",
  });
  const [agreeWhatsApp, setAgreeWhatsApp] = useState(false);
  const [showWhatsAppChat, setShowWhatsAppChat] = useState(false);

  // OTP verification states
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [otp, setOtp] = useState("");
  const [registrationData, setRegistrationData] = useState(null);
  const [otpTimer, setOtpTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  // Time slots for 7 AM to 7 PM
  const generateTimeSlots = () => {
    const times = [];
    let current = new Date();
    current.setHours(7, 0, 0, 0);
    const end = new Date();
    end.setHours(19, 0, 0, 0);

    while (current <= end) {
      const timeString = current.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      times.push(timeString);
      current.setMinutes(current.getMinutes() + 30);
    }
    return times;
  };
  const timeSlots = generateTimeSlots();


  // Add this function at the top of UserInformation.js
  // (after your state declarations, around line 80)

  // Function to generate a URL-friendly slug
  const generateSlug = (text, separator = "-") => {
    return text
      ? text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, separator)
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, separator)
        .replace(/^-+/, "")
        .replace(/-+$/, "")
      : "";
  };


  // Retrieve user info and schedule status from cookies
  useEffect(() => {
    const storedIsLoggedIn = Cookies.get("isLoggedIn") === "true";
    const userName = Cookies.get("userName") || "";
    const userPhone = Cookies.get("phone") || "";
    const tokenFromCookie = Cookies.get("token");
    const isScheduled = Cookies.get(`isScheduled_${propertyId}`) === "true";

    const storedDate = Cookies.get(`visitDate_${propertyId}`);
    const storedTime = Cookies.get(`visitTime_${propertyId}`);
    if (storedDate) setScheduledDate(new Date(storedDate));
    if (storedTime) setScheduledTime(storedTime);

    if (
      storedIsLoggedIn &&
      tokenFromCookie &&
      tokenFromCookie !== "undefined" &&
      tokenFromCookie !== "null" &&
      tokenFromCookie.trim()
    ) {
      setIsLoggedIn(true);
      setUserInfo({
        firstname: userName,
        phone: userPhone,
      });
      setFormData((prev) => ({
        ...prev,
        firstname: userName,
        phone: userPhone,
      }));
    }
  }, [propertyId]);

  // OTP Timer
  useEffect(() => {
    let interval;
    if (showOtpScreen && otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOtpScreen, otpTimer]);

  // Image list for carousel
  const imageList = [
    propertyData?.image_one_url,
    propertyData?.image_two_url,
    propertyData?.image_three_url,
    propertyData?.image_four_url,
  ].filter(Boolean);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % imageList.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + imageList.length) % imageList.length);
  };

  // Modal styles
  const modalStyles = {
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "90vw",
      height: "80vh",
      maxWidth: "500px",
      maxHeight: "475px",
      padding: "20px",
      backgroundColor: "#fff",
      borderRadius: "10px",
      overflow: "hidden"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      zIndex: 999,
    },
  };

  const fetchRandomProperties = async () => {
    try {
      const response = await fetch(`${liveUrl}api/Reactjs/gallery`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      const properties = data?.result || [];
      const filteredProperties = properties
        .filter((prop) => prop.id?.toString() !== propertyId?.toString())
        .sort(() => Math.random() - 0.5)
        .slice(0, 3);
      setSimilarProperties(filteredProperties);
    } catch (error) {
      console.error("Error fetching random properties:", error);
      toast.error("Failed to load random properties", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };

  // Fetch property data
  useEffect(() => {
    const fetchPropertyData = async () => {
      if (!propertyId) {
        toast.error("Invalid property ID", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        setLoader(false);
        return;
      }

      // Reset all state before fetching new data
      setPropertyData(null);
      setSimilarProperties([]);
      setActiveImage("main");
      setCurrentIndex(0);
      setScheduledDate(null);
      setScheduledTime("");

      setLoader(true);
      const userId = Cookies.get("userId");

      try {
        const response = await fetch(
          `${liveUrl}api/PropertyDetail/propertyAllDetails`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: propertyId, userid: userId }),
          }
        );

        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();
        const isScheduled = Cookies.get(`isScheduled_${propertyId}`) === "true";

        setPropertyData({
          ...data?.result?.main_property?.[0],
          is_scheduled:
            isScheduled ||
            data?.result?.main_property?.[0]?.is_scheduled === "true" ||
            data?.result?.main_property?.[0]?.is_scheduled === true,
        });

        const additionalProperties = data?.result?.additional_properties || [];
        if (additionalProperties.length > 0) {
          const filteredAdditional = additionalProperties.filter(
            (prop) => prop.id?.toString() !== propertyId?.toString()
          );
          setSimilarProperties(filteredAdditional);
        } else {
          await fetchRandomProperties();
        }
      } catch (error) {
        console.error("Error fetching property:", error);
        toast.error("Failed to load property data", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        await fetchRandomProperties();
      } finally {
        setLoader(false);
      }
    };

    fetchPropertyData();
    window.scrollTo(0, 0);
  }, [propertyId]);

  // Real-time validation functions
  const validatePhoneNumber = (phone) => /^[0-9]{10}$/.test(phone);
  const validateName = (firstname) => /^[a-zA-Z\s]{2,}$/.test(firstname.trim());

  const validateFieldRealTime = (fieldName, value) => {
    let error = "";
    switch (fieldName) {
      case "firstname":
        if (!value.trim()) {
          error = "Name is required";
        } else if (value.length < 2) {
          error = "Name must be at least 2 characters long";
        } else if (!/^[A-Za-z\s]+$/.test(value.trim())) {
          error = "Name should contain only letters and spaces";
        }
        break;
      case "phone":
        if (!value.trim()) {
          error = "Mobile number is required";
        } else if (value.length < 10) {
          error = `Please enter ${10 - value.length} more digit${10 - value.length > 1 ? "s" : ""
            }`;
        } else if (!/^\d{10}$/.test(value)) {
          error = "Please enter a valid 10-digit mobile number";
        }
        break;
      default:
        break;
    }
    setValidationErrors((prev) => ({
      ...prev,
      [fieldName]: error,
    }));
    return error === "";
  };

  const handleUserInfoChange = (e) => {
    const { name, value } = e.target;
    setFieldTouched((prev) => ({ ...prev, [name]: true }));

    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setUserInfo({ ...userInfo, [name]: numericValue });
      if (fieldTouched[name]) {
        validateFieldRealTime(name, numericValue);
      }
    } else {
      setUserInfo({ ...userInfo, [name]: value });
      if (fieldTouched[name]) {
        validateFieldRealTime(name, value);
      }
    }
  };

  const handleBlur = (fieldName) => {
    setFieldTouched((prev) => ({ ...prev, [fieldName]: true }));
    const value = userInfo[fieldName];
    validateFieldRealTime(fieldName, value);
  };

  const validateForm = () => {
    const newErrors = {
      firstname: "",
      phone: "",
      visitDate: "",
      visitTime: "",
    };
    let isValid = true;

    if (!isLoggedIn) {
      if (!formData.firstname.trim()) {
        newErrors.firstname = "Please enter your name";
        isValid = false;
      } else if (!validateName(formData.firstname)) {
        newErrors.firstname = "Name must be letters only, min 2 characters";
        isValid = false;
      }
      if (!formData.phone.trim()) {
        newErrors.phone = "Please enter your phone number";
        isValid = false;
      } else if (!validatePhoneNumber(formData.phone)) {
        newErrors.phone = "Enter a valid 10-digit phone number";
        isValid = false;
      }
    }
    if (!formData.visitDate) {
      newErrors.visitDate = "Please select a visit date";
      isValid = false;
    }
    if (!formData.visitTime) {
      newErrors.visitTime = "Please select a visit time";
      isValid = false;
    }
    if (userBookings[formData.phone]?.includes(propertyId)) {
      toast.error("You have already booked this property.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setLoader(true);
    if (!validateForm()) {
      setLoader(false);
      return;
    }
    const userId = Cookies.get("userId");
    try {
      const selectedTime = new Date();
      const [time, period] = formData.visitTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      selectedTime.setHours(hours, minutes, 0, 0);
      const payload = {
        firstname: formData.firstname,
        phone: formData.phone,
        property_id: propertyId,
        Userid: userId,
        property_name: propertyData?.name || "N/A",
        type: "properties",
        visitDate: formData.visitDate?.toISOString(),
        visitTime: selectedTime.toISOString(),
      };

      const contactResponse = await fetch(`${liveUrl}api/Contact/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const contactResult = await contactResponse.json();
      if (contactResponse.ok) {
        const meetingsResponse = await fetch(
          `${liveUrl}api/Buyer/scheduleVisit`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const meetingsResult = await meetingsResponse.json();
        if (meetingsResponse.ok) {
          setUserBookings((prev) => ({
            ...prev,
            [formData.phone]: [...(prev[formData.phone] || []), propertyId],
          }));
          toast.success("Your visit has been scheduled successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
          Cookies.set(`isScheduled_${propertyId}`, "true", { expires: 7 });
          Cookies.set(
            `visitDate_${propertyId}`,
            formData.visitDate.toISOString(),
            { expires: 7 }
          );
          Cookies.set(`visitTime_${propertyId}`, formData.visitTime, {
            expires: 7,
          });
          setScheduledDate(formData.visitDate);
          setScheduledTime(formData.visitTime);
          setPropertyData((prev) => ({
            ...prev,
            is_scheduled: true,
          }));
          setFormData({
            firstname: isLoggedIn ? userInfo.firstname : "",
            phone: isLoggedIn ? userInfo.phone : "",
            visitDate: null,
            visitTime: "",
          });
          setModalIsOpen(false);
          setUserInfoModal(false);
        } else {
          toast.error(meetingsResult.message || "Failed to schedule meeting", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      } else {
        if (contactResult.message?.includes("already booked")) {
          setUserBookings((prev) => ({
            ...prev,
            [formData.phone]: [...(prev[formData.phone] || []), propertyId],
          }));
          toast.error("You have already booked this property.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        } else {
          toast.error(contactResult.message || "Failed to schedule visit", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      console.error("Error submitting form:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleUserInfoSubmit = async (e) => {
    e.preventDefault();
    setFieldTouched({
      firstname: true,
      phone: true,
    });
    const isNameValid = validateFieldRealTime("firstname", userInfo.firstname);
    const isPhoneValid = validateFieldRealTime("phone", userInfo.phone);
    if (!isNameValid || !isPhoneValid) {
      setLoader(false);
      return;
    }
    setLoader(true);
    try {
      const contactResponse = await fetch(`${liveUrl}api/User/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: userInfo.firstname.trim(),
          mobile: userInfo.phone.trim(),
        }),
      });
      const contactData = await contactResponse.json();

      if (contactResponse.ok) {
        // Case 1: New user (OTP required)
        if (contactData.status === "done" && contactData.otp) {
          setRegistrationData({
            token: contactData.token,
            id: contactData.id,
            otp: contactData.otp,
            name: userInfo.firstname,
            phone: userInfo.phone,
            isNewUser: true
          });
          // Show OTP screen for new users
          setShowOtpScreen(true);
          setOtpTimer(60);
          setCanResend(false);
          toast.success("OTP sent to your mobile number!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
        // Case 2: Existing user (No OTP required)
        else if (contactData.token || contactData.message?.includes("already exists")) {
          // Set cookies and login the user directly
          Cookies.set("token", contactData.token || "existing_user_token_placeholder", { expires: 7 });
          Cookies.set("userName", userInfo.firstname, { expires: 7 });
          Cookies.set("phone", userInfo.phone, { expires: 7 });
          Cookies.set("isLoggedIn", "true", { expires: 7 });
          Cookies.set("userId", contactData.userid?.toString() || contactData.id?.toString() || "", { expires: 7 });

          // Update state
          setIsLoggedIn(true);
          setFormData((prev) => ({
            ...prev,
            firstname: userInfo.firstname,
            phone: userInfo.phone,
          }));

          // Close user info modal and open schedule modal
          setUserInfoModal(false);
          setTimeout(() => {
            setModalIsOpen(true);
          }, 300);

          toast.success(contactData.message || "Login successful!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        } else {
          toast.error(contactData.message || "Failed to authenticate. Please try again.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      } else {
        toast.error(contactData.message || "Failed to authenticate. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error in user authentication:", error);
      toast.error("An error occurred. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } finally {
      setLoader(false);
    }
  };



  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }

    setLoader(true);
    try {
      const response = await fetch("https://bestpropertiesmohali.com/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mobile: userInfo.phone,
          otp: otp,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "OTP verification failed");
      }

      if (result.status === true || result.message?.includes("verified")) {
        Cookies.set("token", registrationData.token, { expires: 7 });
        Cookies.set("userName", registrationData.name, { expires: 7 });
        Cookies.set("phone", registrationData.phone, { expires: 7 });
        Cookies.set("isLoggedIn", "true", { expires: 7 });
        Cookies.set("userId", registrationData.id, { expires: 7 });

        toast.success("OTP verified! Proceeding to schedule.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });

        setIsLoggedIn(true);
        setFormData((prev) => ({
          ...prev,
          firstname: registrationData.name,
          phone: registrationData.phone,
        }));

        // Close OTP screen and open schedule modal
        setShowOtpScreen(false);
        setTimeout(() => {
          setUserInfoModal(false);
          setModalIsOpen(true);
        }, 300);
      } else {
        toast.error(result.message || "Invalid OTP. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error(error.message || "Failed to verify OTP. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } finally {
      setLoader(false);
    }
  };



  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(value);
  };

  const handleResendOtp = () => {
    setLoader(true);
    setOtp("");

    fetch("https://bestpropertiesmohali.com/api/User/resendOtp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mobile: userInfo.phone,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "done") {
          toast.success("OTP resent successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
          setOtpTimer(60);
          setCanResend(false);
        } else {
          toast.error(data.message || "Failed to resend OTP", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        console.error("Resend OTP Error:", error);
        toast.error("Failed to resend OTP. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleScheduleVisit = () => {
    const tokenFromCookie = Cookies.get("token");
    const isLoggedInCookie = Cookies.get("isLoggedIn") === "true";
    if (
      isLoggedInCookie &&
      tokenFromCookie &&
      tokenFromCookie !== "undefined" &&
      tokenFromCookie !== "null" &&
      tokenFromCookie.trim()
    ) {
      setModalIsOpen(true);
    } else {
      setUserInfoModal(true);
    }
  };

  const handleImageChange = (imageType) => {
    setActiveImage(imageType);
  };

  const normalizeBudget = (panel) => {
    const budgetInWords = panel.budget_in_words || "";
    const budgetValue = panel.budget || "";

    if (budgetInWords) {
      const budgetStr = String(budgetInWords).toLowerCase().trim();

      if (budgetStr.includes("lakh")) {
        const numStr = budgetStr.replace(/[^\d.,]/g, "").replace(/,/g, "");
        const num = parseFloat(numStr);
        if (!isNaN(num)) {
          return num * 100000;
        }
      }

      if (budgetStr.includes("crore")) {
        const numStr = budgetStr.match(/[\d.]+/);
        if (numStr) {
          const num = parseFloat(numStr[0]);
          if (!isNaN(num)) {
            return num * 10000000;
          }
        }
      }
    }

    if (budgetValue) {
      const budgetStr = String(budgetValue).toLowerCase().trim();

      if (!isNaN(budgetValue) && parseInt(budgetValue) > 1000000) {
        return parseInt(budgetValue);
      }

      const numericValue = parseFloat(budgetStr);
      if (!isNaN(numericValue)) {
        if (numericValue <= 100) {
          return numericValue * 10000000;
        }
        return numericValue;
      }
    }

    return 0;
  };

  const formatBudgetDisplay = (panel) => {
    const normalizedBudget = normalizeBudget(panel);

    if (!normalizedBudget || normalizedBudget === 0) {
      if (panel.budget_in_words) {
        return panel.budget_in_words;
      }
      return "Price on Request";
    }

    if (normalizedBudget >= 10000000) {
      return `${(normalizedBudget / 10000000).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} Cr`;
    }

    if (normalizedBudget >= 100000) {
      return `${(normalizedBudget / 100000).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} Lac`;
    }

    if (normalizedBudget >= 1000) {
      return `${(normalizedBudget / 1000).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })} Thousand`;
    }

    return `${normalizedBudget.toLocaleString()}`;
  };

  const renderPropertyImage = () => {
    const imageMap = {
      main: propertyData?.image_one_url,
      two: propertyData?.image_two_url,
      three: propertyData?.image_three_url,
      four: propertyData?.image_four_url,
    };
    return (
      <div className="relative inline-block w-full sm:w-96 h-80">
        <img
          className="w-full h-full object-cover border rounded-lg cursor-pointer"
          src={imageMap[activeImage] || ImageOne}
          alt="Property"
          onClick={() => setImageModal(true)}
        />
        <div className="absolute top-0 left-0 bg-[#d7dde5] text-[#303030] px-2 py-1 text-xs rounded-br">
          ID: {propertyData?.unique_id || "N/A"}
        </div>
      </div>
    );
  };

  const formatScheduledDateTime = () => {
    if (!scheduledDate || !scheduledTime)
      return "Your meeting is already scheduled.";
    const dateStr = scheduledDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return `Visit scheduled on ${dateStr} at ${scheduledTime}`;
  };

  return (
    <>
      <ToastContainer />

      {/* Image Modal */}
      <Modal
        isOpen={imageModal}
        onRequestClose={() => setImageModal(false)}
        style={{
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "90%",
            maxHeight: "90%",
            overflow: "hidden",
            padding: 0,
            backgroundColor: "#fff",
            borderRadius: "10px",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 999,
          },
        }}
      >
        <div className="relative flex items-center justify-center h-full">
          <button
            onClick={() => setImageModal(false)}
            className="absolute top-3 right-3 bg-red-600 w-8 h-8 flex justify-center items-center rounded-full z-20"
          >
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <button
            onClick={handlePrev}
            className="absolute left-2 sm:left-6 bg-white bg-opacity-80 p-2 rounded-full shadow z-10"
          >
            <svg
              className="w-6 h-6 text-black"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <img
            className="w-full h-full object-contain rounded"
            src={imageList[currentIndex] || ImageOne}
            alt={`Property ${currentIndex + 1}`}
          />
          <button
            onClick={handleNext}
            className="absolute right-2 sm:right-6 bg-white bg-opacity-80 p-2 rounded-full shadow z-10"
          >
            <svg
              className="w-6 h-6 text-black"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
        <div className="text-center text-sm text-gray-600 py-2">
          {currentIndex + 1} / {imageList.length}
        </div>
      </Modal>

      {/* User Information Modal */}
      {/* User Information Modal */}
      <Modal
        isOpen={userInfoModal}
        onRequestClose={() => {
          setUserInfoModal(false);
          setShowOtpScreen(false);
        }}
        style={modalStyles}
      >
        <div className="w-full">
          {showOtpScreen ? (
            // OTP Verification Screen
            <>
              <div className="flex justify-between items-center mb-6">
                <h2 className="font-bold text-2xl text-green-800">Verify OTP</h2>
                <button
                  onClick={() => {
                    setShowOtpScreen(false);
                    setOtp("");
                    setUserInfoModal(false);
                  }}
                  className="bg-red-600 w-8 h-8 flex justify-center items-center rounded-full"
                >
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="text-center text-gray-600 mb-4">
                OTP sent to {userInfo.phone}
              </div>
              <div className="mb-6">
                <label className="text-lg font-semibold mb-2 block text-gray-800">
                  Enter OTP
                </label>
                <input
                  type="text"
                  value={otp}
                  onChange={handleOtpChange}
                  className="w-full h-14 border border-green-600 rounded-lg py-3 px-4 text-center text-2xl tracking-widest focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                  maxLength="6"
                  placeholder="000000"
                  autoFocus
                />
              </div>
              <div className="text-center text-sm mb-4">
                {otpTimer > 0 ? (
                  <span className="text-gray-600">Resend OTP in {otpTimer}s</span>
                ) : (
                  <button
                    onClick={handleResendOtp}
                    className="text-blue-600 underline cursor-pointer font-medium"
                    disabled={loader}
                  >
                    Resend OTP
                  </button>
                )}
              </div>
              <button
                onClick={handleVerifyOtp}
                className={`w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg text-lg transition-colors ${loader ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={loader}
              >
                {loader ? "Verifying..." : "Verify OTP"}
              </button>
            </>
          ) : (
            // User Info Form
            <>
              <div className="flex justify-between items-center mb-6">
                <h2 className="font-bold text-2xl text-green-800">
                  Enter Your Details
                </h2>
                <button
                  onClick={() => setUserInfoModal(false)}
                  className="bg-red-600 w-8 h-8 flex justify-center items-center rounded-full"
                >
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <form onSubmit={handleUserInfoSubmit}>
                <div className="mb-6">
                  <label className="text-lg font-semibold border-gray-300 mb-2 block text-gray-800">
                    Your Name*
                  </label>
                  <input
                    className={`w-full h-14 border rounded-lg py-3 px-4 text-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white ${fieldTouched.firstname && validationErrors.firstname
                        ? "border-red-500"
                        : "border-gray-300"
                      }`}
                    name="firstname"
                    value={userInfo.firstname}
                    onChange={handleUserInfoChange}
                    onBlur={() => handleBlur("firstname")}
                    placeholder="Enter your name"
                    required
                  />
                  {fieldTouched.firstname && validationErrors.firstname && (
                    <p className="text-red-600 text-sm mt-2">
                      {validationErrors.firstname}
                    </p>
                  )}
                </div>
                <div className="mb-6">
                  <label className="text-lg font-semibold mb-2 block text-gray-800">
                    Phone Number*
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={userInfo.phone}
                    onChange={handleUserInfoChange}
                    onBlur={() => handleBlur("phone")}
                    className={`w-full h-14 border rounded-lg py-3 px-4 text-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white ${fieldTouched.phone && validationErrors.phone
                        ? "border-red-500"
                        : "border-gray-300"
                      }`}
                    placeholder="Enter your phone number"
                    maxLength="10"
                    required
                  />
                  {fieldTouched.phone && validationErrors.phone && (
                    <p className="text-red-600 text-sm mt-2">
                      {validationErrors.phone}
                    </p>
                  )}
                  <div className="mt-3 flex items-center">
                    <input
                      type="checkbox"
                      id="whatsapp"
                      checked={agreeWhatsApp}
                      onChange={(e) => setAgreeWhatsApp(e.target.checked)}
                      className="mr-2 h-4 w-4"
                    />
                    <label
                      htmlFor="whatsapp"
                      className="text-sm text-black mt-[12px]"
                    >
                      I agree to receive updates on WhatsApp. First please send a
                      "Hi" message on <strong>+91 7719680903</strong>
                    </label>
                  </div>
                </div>
                <button
                  type="submit"
                  className={`w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg text-lg transition-colors ${loader ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  disabled={loader}
                >
                  {loader ? "Processing..." : "Continue"}
                </button>
              </form>
            </>
          )}
        </div>
      </Modal>

      {/* Schedule Visit Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={modalStyles}
      >
        <div className="w-full">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-2xl text-green-800">
              Schedule a Visit
            </h2>
            <button
              onClick={() => setModalIsOpen(false)}
              className="bg-red-600 w-8 h-8 flex justify-center items-center rounded-full"
            >
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <form onSubmit={handleSubmitForm}>
            {!isLoggedIn && (
              <>
                <div className="mb-6">
                  <label className="text-lg font-semibold mb-2 block text-gray-800">
                    Your Name*
                  </label>
                  <input
                    className="w-full h-14 border border-gray-300 rounded-lg py-3 px-4 text-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                    name="firstname"
                    value={formData.firstname}
                    onChange={(e) =>
                      setFormData({ ...formData, firstname: e.target.value })
                    }
                    placeholder="Enter your name"
                    required
                  />
                  {errors.firstname && (
                    <p className="text-red-600 text-sm mt-2">
                      {errors.firstname}
                    </p>
                  )}
                </div>
                <div className="mb-6">
                  <label className="text-lg font-semibold mb-2 block text-gray-800">
                    Phone Number*
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                    className="w-full h-14 border border-gray-300 rounded-lg py-3 px-4 text-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                    placeholder="Enter your phone number"
                    required
                  />
                  {errors.phone && (
                    <p className="text-red-600 text-sm mt-2">{errors.phone}</p>
                  )}
                </div>
              </>
            )}
            <div className="mb-6">
              <label className="text-lg font-semibold mb-2 block text-gray-800">
                Visit Date*
              </label>
              <DatePicker
                selected={formData.visitDate}
                onChange={(date) =>
                  setFormData({ ...formData, visitDate: date })
                }
                minDate={new Date()}
                className="w-full h-14 border border-gray-300 rounded-lg py-3 px-4 text-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                placeholderText="Select a date"
                disabled={loader}
                popperPlacement="bottom"
                wrapperClassName="w-full"
                calendarClassName="border border-gray-300 rounded-lg shadow-lg bg-white"
                dayClassName={() =>
                  "text-gray-800 hover:bg-green-100 cursor-pointer p-2"
                }
              />
              {errors.visitDate && (
                <p className="text-red-600 text-sm mt-2">{errors.visitDate}</p>
              )}
            </div>
            <div className="mb-6">
              <label className="text-lg font-semibold mb-2 block text-gray-800">
                Visit Time*
              </label>
              <select
                value={formData.visitTime}
                onChange={(e) =>
                  setFormData({ ...formData, visitTime: e.target.value })
                }
                className="w-full h-14 border border-gray-300 rounded-lg py-3 px-4 text-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                disabled={loader}
                required
              >
                <option value="" disabled>
                  Select a time
                </option>
                {timeSlots.map((time) => (
                  <option key={time} value={time}>
                    {time}
                  </option>
                ))}
              </select>
              {errors.visitTime && (
                <p className="text-red-600 text-sm mt-2">{errors.visitTime}</p>
              )}
            </div>
            <button
              type="submit"
              className={`w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg text-lg transition-colors ${loader ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loader}
            >
              {loader ? "Submitting..." : "Schedule Visit"}
            </button>
          </form>
        </div>
      </Modal>

      {/* Report Modal */}
      <Modal
        isOpen={showReport}
        onRequestClose={() => setShowReport(false)}
        style={modalStyles}
      >
        <div className="w-full">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-2xl text-green-800">Add Comment</h2>
            <button
              onClick={() => setShowReport(false)}
              className="bg-red-600 w-8 h-8 flex justify-center items-center rounded-full"
            >
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <Report isLoggedIn={isLoggedIn} />
        </div>
      </Modal>

      {/* WhatsAppChat Modal */}
      <Modal
        isOpen={showWhatsAppChat}
        onRequestClose={() => setShowWhatsAppChat(false)}
        style={modalStyles}
      >
        <div className="w-full">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-2xl text-green-800">WhatsApp Chat</h2>
            <button
              onClick={() => setShowWhatsAppChat(false)}
              className="bg-red-600 w-8 h-8 flex justify-center items-center rounded-full"
            >
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <WhatsAppChat
            phoneNumber="+917719680903"
            onClose={() => setShowWhatsAppChat(false)}
          />
        </div>
      </Modal>

      <Navbar />
      <div className="relative">
        <div
          className="
            absolute flex flex-col items-end gap-3 z-50
            top-[17%] right-3          
            sm:top-[2%] sm:right-3    
            md:top-[20%] md:right-4    
            lg:top-[3%] lg:right-6    
          "
        >
          {/* Back Button */}
          <button
            onClick={() => navigate("/Property")}
            className=" text-black font-bold px-4 py-2 bg-gray-400 transition"
          >
            Back
          </button>




          {/* Bug Icon */}
          <FaFlag
            onClick={() => setShowReport(true)}
            className="text-red-900 cursor-pointer  transition"
            size={28}
          />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-7xl">
          {loader ? (
            <div className="flex justify-center items-center py-8">
              <svg
                className="animate-spin h-10 w-10 text-gray-600"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM304 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                />
              </svg>
            </div>
          ) : !propertyData ? (
            <div className="text-center font-semibold text-xl text-gray-800">
              No Property Data Found
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row gap-4 rounded-lg p-4 bg-white shadow-sm">
              <div className="flex-shrink-0 w-full sm:w-96">
                {renderPropertyImage()}
                <div className="flex gap-2 mt-2 justify-center sm:justify-start">
                  {propertyData.image_two_url && (
                    <img
                      onClick={() => handleImageChange("two")}
                      className="h-16 w-16 object-cover border border-gray-300 rounded cursor-pointer hover:border-green-500"
                      src={propertyData.image_two_url}
                      alt="Thumbnail Two"
                    />
                  )}
                  {propertyData.image_three_url && (
                    <img
                      onClick={() => handleImageChange("three")}
                      className="h-16 w-16 object-cover border border-gray-300 rounded cursor-pointer hover:border-green-500"
                      src={propertyData.image_three_url}
                      alt="Thumbnail Three"
                    />
                  )}
                  {propertyData.image_four_url && (
                    <img
                      onClick={() => handleImageChange("four")}
                      className="h-16 w-16 object-cover border border-gray-300 rounded cursor-pointer hover:border-green-500"
                      src={propertyData.image_four_url}
                      alt="Thumbnail Four"
                    />
                  )}
                </div>
              </div>
              <div className="flex-1 flex flex-col p-4">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <svg
                      className="w-6 h-6 text-gray-600"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      fill="currentColor"
                    >
                      <path d="M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z" />
                    </svg>
                    <div className="text-xl sm:text-2xl font-semibold text-gray-800">
                      {formatBudgetDisplay(propertyData)}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                    <h1 className="text-xl sm:text-2xl font-semibold text-gray-600">
                      {propertyData.name || "N/A"}
                    </h1>
                  </div>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2 mb-2 text-base sm:text-lg">
                  <div className="flex items-center gap-2">
                    <span className="text-gray-600 font-semibold">
                      {propertyData.property_type || "N/A"}
                    </span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-2">
                  {propertyData.bathrooms > 0 && (
                    <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-lg">
                      <img className="w-5 h-5" src={Bath} alt="Bath" />
                      <span className="font-semibold text-sm">
                        {propertyData.bathrooms} Baths
                      </span>
                    </div>
                  )}
                  {propertyData.bedrooms > 0 && (
                    <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-lg">
                      <img className="w-5 h-5" src={Bed} alt="Bed" />
                      <span className="font-semibold text-sm">
                        {propertyData.bedrooms} Beds
                      </span>
                    </div>
                  )}
                  {propertyData.bhk > 0 && (
                    <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-lg">
                      <img className="w-5 h-5" src={Bed} alt="Bed" />
                      <span className="font-semibold text-sm">
                        {propertyData.bhk} BHK
                      </span>
                    </div>
                  )}
                  {propertyData.kitchen > 0 && (
                    <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-lg">
                      <img className="w-5 h-5" src={Kitchen} alt="Kitchen" />
                      <span className="font-semibold text-sm">
                        {propertyData.kitchen} Kitchen
                      </span>
                    </div>
                  )}
                </div>
                <div className="flex gap-3 w-full mb-4">
                  {propertyData?.is_scheduled ? (
                    <button
                      className="flex-1 bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
                      disabled
                    >
                      {formatScheduledDateTime()}
                    </button>
                  ) : (
                    <button
                      onClick={handleScheduleVisit}
                      className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
                    >
                      Schedule a Visit
                    </button>
                  )}

                  <button
                    onClick={() => setShowWhatsAppChat(true)}
                    aria-label="Open WhatsApp Chat"
                    className="flex-1 bg-green-200 hover:bg-green-300 rounded-lg p-2 flex items-center justify-center font-semibold"
                  >Chat With Us
                    <svg
                      fill="#25D366"
                      xmlns="http://www.w3.org/2000/svg"
                      height="30"
                      width="30"
                      viewBox="0 0 448 512"
                      className="h-8 w-8"
                    >
                      <path d="M92.1 254.6c0 24.9 7 49.2..." />
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div
                    className={`border border-gray-200 rounded-lg p-4 bg-gray-50 transition-all ${showAllAmenities ? "min-h-[400px]" : "min-h-[150px]"
                      }`}
                  >
                    <h3 className="font-semibold text-lg mb-2 text-green-800">
                      Amenities
                    </h3>
                    <div className="space-y-1">
                      {propertyData.amenities ? (
                        propertyData.amenities
                          .split("~-~")
                          .slice(0, showAllAmenities ? undefined : 5)
                          .map((amenity, index) => (
                            <div key={index} className="flex items-center gap-2">
                              <svg
                                className="w-2 h-2 text-green-600"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  fill="currentColor"
                                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
                                />
                              </svg>
                              <span className="text-sm">{amenity.trim()}</span>
                            </div>
                          ))
                      ) : (
                        <p className="text-sm text-gray-600">
                          No amenities listed
                        </p>
                      )}
                      <div className="flex flex-wrap gap-2 text-sm mt-2">
                        {propertyData.property_for && (
                          <span>
                            <strong>Property For:</strong>{" "}
                            {propertyData.property_for}
                          </span>
                        )}
                        {propertyData.built && (
                          <span>
                            <strong>Built Area:</strong> {propertyData.built}{" "}
                            {propertyData.built_unit
                              ? propertyData.built_unit
                              : "Sq.Ft."}
                          </span>
                        )}
                        {propertyData.land && (
                          <span>
                            <strong>Land Area:</strong> {propertyData.land}{" "}
                            {propertyData.land_unit
                              ? propertyData.land_unit
                              : "Sq.Ft."}
                          </span>
                        )}
                        {propertyData.bhk && (
                          <span>
                            <strong>BHK:</strong> {propertyData.bhk}
                          </span>
                        )}
                        {propertyData.services && (
                          <span>
                            <strong>Services:</strong> {propertyData.services}
                          </span>
                        )}
                      </div>
                      {propertyData.amenities?.split("~-~").length > 5 && (
                        <button
                          onClick={() => setShowAllAmenities(!showAllAmenities)}
                          className="text-green-600 text-sm font-semibold mt-2 hover:underline"
                        >
                          {showAllAmenities ? "Show Less" : "Show More"}
                        </button>
                      )}
                    </div>
                  </div>
                  <div
                    className={`border border-gray-200 rounded-lg p-4 bg-gray-50 transition-all ${showAllDetails ? "min-h-[300px]" : "min-h-[150px]"
                      }`}
                  >
                    <h3 className="font-semibold text-lg mb-2 text-green-800">
                      Property Details
                    </h3>
                    <h6 className="font-semibold text-[11px] mb-2 text-red-600">
                      The price shown is only an indication of the current market
                      rate. Actual property prices may vary over time.
                    </h6>
                    <div
                      className={`space-y-2 ${!showAllDetails ? "max-h-[5.5rem] overflow-hidden" : ""
                        }`}
                    >
                      {propertyData.address && (
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-1">
                            Address:
                          </h4>
                          <p className="text-gray-700 text-sm">
                            {propertyData.address}
                          </p>
                        </div>
                      )}
                      {propertyData.sqft && (
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-1">
                            Area:
                          </h4>
                          <p className="text-gray-700 text-sm">
                            {propertyData.sqft}{" "}
                            {propertyData.measureUnit || "Sq.Ft."}
                          </p>
                        </div>
                      )}
                      {propertyData.description && (
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-1">
                            Description:
                          </h4>
                          <p className="text-gray-700 text-sm leading-relaxed">
                            {propertyData.description}
                          </p>
                        </div>
                      )}
                      {propertyData.property_type && (
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-1">
                            Property Type:
                          </h4>
                          <p className="text-gray-700 text-sm">
                            {propertyData.property_type}
                          </p>
                        </div>
                      )}
                    </div>
                    {(propertyData.description ||
                      propertyData.sqft ||
                      propertyData.address ||
                      propertyData.property_type) && (
                        <button
                          onClick={() => setShowAllDetails(!showAllDetails)}
                          className="text-green-600 text-sm font-semibold mt-2 hover:underline"
                        >
                          {showAllDetails ? "Show Less" : "Show More"}
                        </button>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="mt-8">
            <h2 className="text-xl sm:text-2xl uppercase font-semibold text-center text-green-800">
              <AnimatedText text="Other Similar Properties Near By" />
            </h2>

            {loader ? (
              <div className="flex justify-center items-center py-8">
                <svg
                  className="animate-spin h-10 w-10 text-gray-600"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM304 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                  />
                </svg>
              </div>
            ) : similarProperties.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
                {similarProperties.map((property) => (
                  <div
                    key={property.id}
                    onClick={() => {
                      const slug = generateSlug(property.name || `property-${property.id}`);
                      navigate(`/property/${slug}-${property.id}`);
                      window.location.reload(); // Force reload for now
                    }}
                    className="shadow-lg cursor-pointer p-4 border bg-white rounded-lg hover:shadow-xl transition-shadow group"
                  >
                    <div className="relative overflow-hidden rounded-lg">
                      <img
                        className="h-52 w-full object-cover transform transition-transform duration-500 group-hover:scale-110"
                        src={property.image_one_url || ImageOne}
                        alt={property.name || 'Property'}
                      />
                      <div className="absolute bottom-0 left-0 bg-[#d7dde5] text-[#303030] px-2 py-1 text-xs">
                        ID: {property.unique_id || 'N/A'}
                      </div>
                    </div>

                    <div className="mt-2">
                      <h3 className="font-semibold text-base sm:text-lg text-green-800">
                        {property.name || 'N/A'}
                      </h3>

                      <div className="flex items-center gap-2">
                        <svg
                          className="w-4 h-4 text-green-600"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 320 512"
                          fill="currentColor"
                        >
                          <path d="M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z" />
                        </svg>
                        <span className="font-semibold text-sm text-green-600">
                          {formatBudgetDisplay(property)}
                        </span>
                      </div>

                      <div className="flex items-center gap-2 mt-1">
                        <svg
                          className="h-4 w-4 text-green-800"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 384 512"
                        >
                          <path d="M215.7 499.2C267 435 384 64 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                        </svg>
                        <span className="text-sm text-gray-700">
                          {property.address || 'N/A'}
                        </span>
                      </div>

                      <div className="flex items-center gap-3 mt-2">
                        {property.bathrooms > 0 && (
                          <div className="flex items-center gap-2">
                            <img className="w-5 h-5" src={Bath} alt="Bath" />
                            <span className="text-sm">{property.bathrooms}</span>
                          </div>
                        )}
                        {property.bedrooms > 0 && (
                          <div className="flex items-center gap-2">
                            <img className="w-5 h-5" src={Bed} alt="Bed" />
                            <span className="text-sm">{property.bedrooms}</span>
                          </div>
                        )}
                        {property.bhk > 0 && (
                          <div className="flex items-center gap-2">
                            <img className="w-5 h-5" src={Bed} alt="Bed" />
                            <span className="text-sm">{property.bhk}</span>
                          </div>
                        )}
                        {property.verified && (
                          <div className="flex items-center gap-2">
                            <img
                              className="w-5 h-5"
                              src={property.verified}
                              alt="Verified"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center mt-6 text-sm text-gray-600">
                No properties found.
              </div>
            )}
          </div>

        </div>
      </div>
      <OurServices />
      <Searching />
      <BottomBar />
    </>
  );
}
